import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IParsePostingApiRequest, IParsePostingApiResponse } from '../types';

/**
 * Read-only parse endpoint — sends the pasted text to the LLM and returns the
 * extracted fields. Does NOT persist anything; the caller creates the draft.
 */
export const parsePosting = async (
  payload: IParsePostingApiRequest,
): Promise<IParsePostingApiResponse> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.post<IParsePostingApiResponse>(
    '/posting-service/postings/parse',
    payload,
    { headers },
  );

  return response.data;
};
